import { Card, Link, Typography } from '@volvo/vcdk-react';
import React from 'react';

type Props = {
  imageSrc: string;
  tag: string;
  title: string;
  description: string;
  linkText: string;
  linkHref: string;
};

const SectionCard: React.FC<Props> = ({ imageSrc, tag, title, description, linkText, linkHref }) => {
  return (
    <Card className="flex">
      <img src={`${import.meta.env.VITE_BASE_PATH}${imageSrc}`} loading="lazy" className="h-auto w-auto object-cover" />
      <div className="flex flex-1 flex-col gap-6 p-8">
        <div className="flex flex-col gap-2">
          <Typography variant="caption2" className="text-subtle">
            {tag}
          </Typography>
          <Typography variant="heading4" className="block">
            {title}
          </Typography>
        </div>
        <Typography className="">{description}</Typography>
        <Link icon="arrow-right" iconPosition="end" href={linkHref} target="_blank" rel="noopener noreferrer">
          {linkText}
        </Link>
      </div>
    </Card>
  );
};

export default SectionCard;
